export default defineNuxtRouteMiddleware((to, from) => {
  const fromLayout = from.meta?.layout || 'default'
  const toLayout = to.meta?.layout || 'default'

  const isTeamNext = toLayout === 'team'
  const isTeamCurrent = fromLayout === 'team'

  const isTeamLayoutChanged = isTeamCurrent !== isTeamNext

  if (isTeamLayoutChanged) {
    return navigateTo(to.fullPath, { external: true })
  }
})
